import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import QRCode        from 'react-qr-code';

import BasicModal       from '@partials/basic-modal';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class DraftAdminEdit extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal: false,
    };
  }
  // -------------------------------------------------------
  
  toggleModal(flg) {
    this.setState({ modal: flg });
  }
  // -------------------------------------------------------
  
  closeModal() {
    this.setState({ modal: false });
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.props.detail;
    
    // 下書き編集リンク
    let draft_link = 'https://casting.moribus.jp/project/manual/'+ this.props.base.project.unique_code +'/'+ detail.draft.unique_id;
    
    // アクション
    if( detail.workflow_status.is_draft_complete != 1 && detail.draft.unique_id != undefined && detail.workflow_status.is_entry == 1 ){
      return (
        <div>
          <li className="on" onClick={this.toggleModal.bind(this, true)}>
            {this.props.button}
          </li>
          
          {(this.state.modal == true) &&
            <BasicModal
              modal_active={true}
              title = "管理者権限で下書きを編集"
              sub_title = {<span className="alert">{Moment().add(7, 'days').format('YYYY年M月D日')} に有効期限が切れます。ご注意ください。</span>}
              width = {400}
              contents = {
                <div>
                  <a className="qr-link" href={draft_link} target="_blank">編集用のURL</a>
                  <div className="qr">
                    <QRCode size={100} style={{ height: "auto", maxWidth: "100%", width: "100%" }} value={draft_link} viewBox={`0 0 256 256`} />
                  </div>
                </div>
              }
              contents_height = {140}
              buttons = {
                [{ id: 'yes', name: '閉じる', event: this.closeModal.bind(this)}]
              }
            />
          }
        </div>
      );
    }
    
    // 使用できない
    let msg = '現在、使用できません。';
    if( detail.workflow_status.is_draft_complete == 1 ) msg = '下書き検収済みのため、機能を利用できません';
    if( detail.workflow_status.is_entry != 1 ) msg = 'エントリーしていないため、機能を利用できません';
    
    return (
      <OverlayTrigger placement="left" delayShow={50} overlay={<Tooltip>{msg}</Tooltip>}>
        <li className="off">
          {this.props.button}
        </li>
      </OverlayTrigger>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftAdminEdit;